import { AfterViewInit, Directive, ElementRef, Inject, OnDestroy, PLATFORM_ID } from '@angular/core';
import { IFrameComponent, iframeResizer } from 'iframe-resizer';
import { isPlatformBrowser } from '@angular/common';

@Directive({
  selector: '[wcIframeResizer]',
  standalone: true
})
export class IFrameResizerDirective implements AfterViewInit, OnDestroy {
  component: IFrameComponent;

  constructor(
    public element: ElementRef,
    @Inject(PLATFORM_ID) private platformId: any
  ) {}

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      (this.element.nativeElement as HTMLIFrameElement).onload = () => this.initIframeResizer();
    }
  }

  private initIframeResizer(): void {
    const components = iframeResizer({
      heightCalculationMethod: 'documentElementOffset',
      checkOrigin: false,
      log: false
    }, this.element.nativeElement);

    this.component = components && components.length > 0 ? components[0] : null;
    (this.element.nativeElement as HTMLIFrameElement).onload = undefined;
  }

  ngOnDestroy(): void {
    this.component?.iFrameResizer?.close();
  }
}
